import React from "react";
import FormTextArea from "../../../../../../components/common/PL/TextInput/FormTextArea";

type ObservationsTextAreaProps = {
  name: string;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
};

const ObservationsTextArea: React.FC<ObservationsTextAreaProps> = ({
  name,
  label,
  placeholder,
  disabled,
}) => {
  return <FormTextArea name={name} label={label} placeholder={placeholder} rows={6} disabled={disabled} />;
};

export default ObservationsTextArea;
